import $ from 'jquery';
import { find } from 'lodash';
import CommentModel from 'models/CommentModel';
import saveCommentsAsync from 'repositories/saveCommentsAsync';
import { repository as loadRepository } from 'repositories/loadCommentsAsync';
import CommentsService from '@ui/comments/CommentService';
import { setLabel } from '@ui/comments/filters';
import { siteModel } from 'models/SiteModel';
import { scroller as loginBarScroller } from '@ui/login-bar/scroller';

export const elements = {
    form: '.c-comments form.c-comments__content',
    formContainer: '.comment-textfield',
    button: '.c-comments__btn',
    sendButton: '.c-comments__btn--send',
    input: '.text-editor',
};

export const saveRepository = new saveCommentsAsync();

export const send = function (event) {
    event.preventDefault();

    const button = $(this);
    const form = button.parents(elements.form);
    const container = form.find(elements.formContainer);
    const input = form.find(elements.input);
    const parent = form.attr('data-parent');

    let message = input.html().replace(/<(br)[^<]*?>/g, '\n').replace(/<div>/g, '').replace(/<\/div>/g, '\n').trim();

    input.html(message);
    message = input.text();

    const item = {
        message,
        user: '',
        parentCommentId: parent,
    };

    if (form.attr('data-id')) {
        item.id = form.attr('data-id');
    }

    if (CommentModel.isMessageCorrect(item.message)) {
      container.addClass('is-loading');
      if (item.id) {
        document.dispatchEvent(new CustomEvent('EditComment', {
          detail: { item },
        }));
      } else {
        if (_.isNil(item.parentCommentId)) {
          document.dispatchEvent(new CustomEvent('AddBaseComment', {
            detail: { item },
          }));
        } else {
          document.dispatchEvent(new CustomEvent('AddReplyComment', {
            detail: { item },
          }));
        }
      }
    }
};

export const captureFormFocus = function (event) {
    const form = $(this);
    const input = form.find(elements.input)[0];
    const message = input.textContent;
    const button = form.find(elements.button);

    if (CommentModel.isMessageCorrect(message)) {
        button.removeClass('hide');
    } else {
        button.addClass('hide');
    }
};

// export const captureFormKeypres = function (event) {
//     if (event.keyCode == 13 && !event.shiftKey) {
//         send.call(this, event);
//     }
// };

export const init = (params) => {
    document.execCommand('insertBrOnReturn', false, true);
    params
        .$document
        .on('submit', elements.form, (event) => {
          event.preventDefault();
        })
        .on('input', elements.form, captureFormFocus)
        .on('click', elements.sendButton, send);

    if (!siteModel.isUserLogged()) {
      const input = $(elements.input);
      input.removeAttr('contenteditable');
      input.html(`<span class="placeholder">` + input.attr('placeholder') + `</span>`)
      input.on('click', function (event) {
        event.preventDefault();
        $(this).attr('disabled', true);
        loginBarScroller();
      });
    }

    const successCallback = () => {
      const form = $(elements.form);
      form.find(elements.input).html('');
      form.find(elements.button).addClass('hide');
      setLabel('date');
    };

    document.addEventListener('AddBaseCommentSuccess', (event) => {
      successCallback();
    });
    document.addEventListener('AddBaseCommentFailure', (event) => {
      successCallback();
    });
}

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/add-comment.js